<div class="flex items-center justify-center">
  <div class="text-center">
    <h1 class="text-6xl font-bold text-gray-800 mb-4">404</h1>
    <h2 class="text-2xl font-semibold text-gray-600 mb-2">
      Pagina Non Trovata
    </h2>
  </div>
</div>
